export const intervalModeIds = {
  withoutExpert: 0,
  withExpert: 1,
  universal: 2,
};

export const expertIntervalModes = new Set([
  intervalModeIds.withExpert,
  intervalModeIds.withoutExpert,
]);

export const intervalModes = new Map([
  [intervalModeIds.withoutExpert, 'Без эксперта'],
  [intervalModeIds.withExpert, 'С экспертом'],
  [intervalModeIds.universal, 'Универсальный'],
]);

export const defaultIntervalMode = 2;
